// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:57:13

export default {
  "id": "merge-run-battle",
  "slug": "merge-run-battle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/258fa7dc41f84555b1e84fc462784378-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/258fa7dc41f84555b1e84fc462784378/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Merge Run Battle",
      "description": "Merge and defeat all enemies!\n\nHave you ever played best gameplay with merge and fighting?\n\nIf you want to look for a top game in the simple running and merge game, adventure game Merge Run Battle is the best choice of simulator game for you.\n\nRun to collect your teammates of the same level into more powerful. The final level character has extremely destructive power.\n\nAt the end of the race, you need to think quick and act fast, merge them all to get more power and win the battle.\n",
      "instructions": "Swipe horizontally to control.",
      "genres": [
        "Casual",
        "Shooter"
      ],
      "tags": [
        "1player",
        "2048",
        "beach",
        "shoot-em-up"
      ]
    },
    "zh-CN": {
      "title": "合并跑酷战斗",
      "description": "合并并击败所有敌人！\n\n你是否玩过最好的合并与战斗游戏体验？\n\n如果你想在简单的跑步和合并游戏中寻找顶级游戏，《冒险游戏合并跑斗》是为你提供的最佳模拟游戏选择。\n\n跑步收集相同等级的队友，变得更加强大。最终关卡的角色拥有极强的破坏力。\n\n在比赛结束时，你需要快速思考并迅速行动，合并他们以获得更多力量并赢得战斗。",
      "instructions": "水平滑动以控制。",
      "genres": [
        "休闲",
        "射击"
      ],
      "tags": [
        "1玩家",
        "2048",
        "海滩",
        "射击游戏"
      ]
    },
    "zh-TW": {
      "title": "合併競速戰鬥",
      "description": "合併並擊敗所有敵人！\n\n你是否曾經玩過最佳合併與戰鬥遊戲體驗？\n\n如果你想要尋找簡單跑酷合併遊戲中的頂尖遊戲，冒險遊戲《合併跑酷戰》是你最佳選擇的模擬遊戲。\n\n奔跑以收集同級隊友，讓他們變得更強大。最終級別的角色擁有極其毀滅性的力量。\n\n比賽結束時，你需要迅速思考並迅速行動，合併他們以獲得更多力量並贏得戰鬥。",
      "instructions": "水平滑動以控制。",
      "genres": [
        "休闲",
        "射擊"
      ],
      "tags": [
        "1玩家",
        "2048",
        "海灘",
        "射擊遊戲"
      ]
    },
    "zh-HK": {
      "title": "合體跑戰",
      "description": "合併並擊敗所有敵人！\n\n你曾經玩過最佳合併與戰鬥遊戲體驗嗎？\n\n如果你想在簡單的奔跑與合併遊戲中尋找頂級遊戲，《冒險合併跑戰》是你最佳的选择模擬遊戲。\n\n奔跑以收集與你同級的隊友，讓他們變得更強大。最終等級的角色擁有極其破壞性的力氣。\n\n比賽結束時，你需要快速思考及迅速行動，合併所有人以獲得更多力量並赢得戰鬥。",
      "instructions": "水平滑動以控制。",
      "genres": [
        "休闲",
        "射擊"
      ],
      "tags": [
        "1玩家",
        "2048",
        "海滩",
        "射擊遊戲"
      ]
    },
    "ja": {
      "title": "マージランバット",
      "description": "すべての敵を合体させて討伐せよ！\n\n合体と戦闘で最高のプレイを体験したことはありますか？\n\nシンプルなランニングと合体のゲームでトップのゲームを見つけたい場合は、冒険ゲーム「Merge Run Battle」があなたのための最高のシミュレーションゲームです。\n\n走って同じレベルのチームメイトを集め、より強力なものに合体させよう。最終レベルのキャラクターは非常に破壊的な力を持っています。\n\nレースの終わりには、素早く考え、素早く行動して、すべてを合体させてさらに力を得て戦勝を勝ち取る必要があります。",
      "instructions": "横にスワイプして操作してください。",
      "genres": [
        "カジュアル",
        "シューティング"
      ],
      "tags": [
        "1プレイヤー",
        "2048",
        "ビーチ",
        "シューティングゲーム"
      ]
    },
    "ko": {
      "title": "콧소리 전투 합성",
      "description": "모든 적을 합치고 공격하라!\n\n합치기와 싸움의 최고의 게임 플레이를 즐겨보았나요?\n\n간단한 달리기와 합치기 게임, 모험 게임 Merge Run Battle가 귀하분의 시뮬레이터 게임으로는 최상의 선택입니다.\n\n달려가 동일 수준의 동료를 모아 더 강력한 것으로 만들어보세요. 최종 레벨 캐릭터는 극도로 파괴력을 가지고 있습니다.\n\n레이스의 마지막 순간에는 빠르게 생각하고 빠르게 행동해야 합니다. 모두를 합치고 더 많은 힘을 얻어 전투를 승리하세요.",
      "instructions": "수평으로 스와이프하여 조작하세요.",
      "genres": [
        "캐주얼",
        "셔터"
      ],
      "tags": [
        "1플레이어",
        "2048",
        "해변",
        "쏘옷업"
      ]
    },
    "fr": {
      "title": "Course de fusion combat",
      "description": "Fusionnez et vainquez tous les ennemis !\n\nAvez-vous déjà joué à la meilleure partie de jeu avec fusion et combat ?\n\nSi vous cherchez un jeu de course simple et de fusion, le jeu d'aventure Merge Run Battle est le meilleur choix de simulateur de jeu pour vous.\n\nCoursez pour recueillir vos coéquipiers du même niveau et les rendre plus puissants. Le personnage du niveau final a une puissance destructrice extrême.\n\nÀ la fin de la course, vous devez réfléchir rapidement et agir vite, fusionnez-les tous pour obtenir plus de puissance et gagner la bataille.",
      "instructions": "Faites glisser latéralement pour contrôler.",
      "genres": [
        "Facile",
        "Tiroir"
      ],
      "tags": [
        "1 joueur",
        "2048",
        "plage",
        "tirelire"
      ]
    }
  }
};
